import type { InstallationHeights } from "./types";

export const DEFAULT_INSTALLATION_HEIGHTS: InstallationHeights = {
  floorM: 0,
  controlsM: 1.5,
  luminaireM: 3,
  ceilingVoidM: 3.5,
};

export const DEFAULT_BOARD_HEIGHT_M = 2;

export const INSTALLATION_HEIGHT_KEYS: Array<keyof InstallationHeights> = [
  "floorM",
  "controlsM",
  "luminaireM",
  "ceilingVoidM",
];

export const FLOOR_TRAY_PATTERN = /boden|unterflur/i;
export const PARAPET_TRAY_PATTERN = /brüstung|bruestung/i;
